import { render, staticRenderFns } from "./the-3-4-5-method.vue?vue&type=template&id=5d857b62&"
import script from "./the-3-4-5-method.vue?vue&type=script&lang=js&"
export * from "./the-3-4-5-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports